export function importQueueHideCompletedStorageKey(domainKey: string): string {
  return `import-queue-hide-completed:${domainKey}`;
}
